import React, { useEffect, useRef } from 'react';
import {
  FaSearch,
  FaShoppingCart,
  FaCreditCard,
  FaTruck,
} from 'react-icons/fa';

const Process = () => {
  const ref = useRef(null);
  useEffect(() => {
    const io = new IntersectionObserver(
      (e) =>
        e.forEach((x) => x.isIntersecting && x.target.classList.add('show')),
      { threshold: 0.2 }
    );
    ref.current?.querySelectorAll('.reveal').forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  const steps = [
    {
      icon: <FaSearch />,
      title: 'Browse the Menu',
      desc: 'Meals & fresh vegetables in one place',
    },
    {
      icon: <FaShoppingCart />,
      title: 'Select Items',
      desc: 'Customize spice, add‑ons and swaps',
    },
    {
      icon: <FaCreditCard />,
      title: 'Place Order',
      desc: 'UPI, cards, wallets or COD',
    },
    {
      icon: <FaTruck />,
      title: 'Track Delivery',
      desc: 'Live route from kitchen/market',
    },
  ];
  return (
    <section
      id="process"
      className="section"
      style={{
        background:
          'radial-gradient(900px 500px at 10% 0%, rgba(255,122,61,.15), transparent 60%), radial-gradient(900px 500px at 100% 100%, rgba(0,212,166,.12), transparent 55%)',
      }}
    >
      <div className="container" ref={ref}>
        <div
          className="reveal"
          style={{ textAlign: 'center', marginBottom: 28 }}
        >
          <h2 className="title">How to Use the App</h2>
          <p className="subtitle">
            Getting your favorite meals and fresh vegetables is easier than
            ever.
          </p>
        </div>
        <div className="grid grid-4">
          {steps.map((s, i) => (
            <div
              key={i}
              className="reveal card"
              style={{ padding: 24, textAlign: 'center' }}
            >
              <div
                style={{
                  width: 62,
                  height: 62,
                  borderRadius: 18,
                  background: 'var(--grad)',
                  display: 'grid',
                  placeItems: 'center',
                  color: '#0a0a0a',
                  fontSize: 24,
                  margin: '0 auto 12px',
                }}
              >
                {s.icon}
              </div>
              <div style={{ fontWeight: 800, marginBottom: 6 }}>{s.title}</div>
              <div style={{ color: 'var(--muted)' }}>{s.desc}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Process;
